import type { ProfileModel } from "../types/models";

// "pricing-pro-59" experiment: Pro's monthly price for new signups. Control
// keeps $79; the "pro-59" arm sees and pays $59 (yearly: the same 50% off,
// $29/mo). Basic and Pro+ never change. klap-api reads the same flag when a
// checkout, plan switch or upgrade preview targets Pro
// (helpers/pro_price_experiment.ts there), so the price charged is the price
// shown. Delete with the experiment.

export type ProPriceVariant = "control" | "pro-59";

export const PRO_PRICE_FLAG_KEY = "pricing-pro-59";

// Must equal klap-api's PRO_PRICE_EXPERIMENT_LAUNCH_DATE and the flag's
// signed_up_at release condition in PostHog.
export const PRO_PRICE_EXPERIMENT_LAUNCH_DATE = new Date(
  "2026-10-05T17:45:00Z",
);

export const PRO_MONTHLY_PRICE: Record<ProPriceVariant, number> = {
  control: 79,
  "pro-59": 59,
};

// Non-guest profiles created on/after the launch date, free or paying: a
// signup who buys Basic keeps their arm's Pro price when upgrading. Older
// users and logged-out /pricing visitors never evaluate the flag and see $79.
export const isProPriceExperimentEligible = (
  profile?: Pick<ProfileModel, "isGuest" | "createdAt"> | null,
): boolean =>
  !!profile &&
  !profile.isGuest &&
  !!profile.createdAt &&
  new Date(profile.createdAt) >= PRO_PRICE_EXPERIMENT_LAUNCH_DATE;

// Anything but the "pro-59" arm (control, not enrolled, flags not loaded)
// sees today's $79.
export const proPriceVariantFor = (
  variant: string | boolean | undefined | null,
): ProPriceVariant => (variant === "pro-59" ? "pro-59" : "control");
